/** 客戶租戶帳號類型（總帳與員工共用） */
export const CLIENT_ACCOUNT_TYPE = 'client';
export const CLIENT_OWNER_ROLE = 'client_owner';
export const CLIENT_STAFF_ROLE = 'client_staff';

export function isClientAccountType(accountType) {
  return accountType === CLIENT_ACCOUNT_TYPE;
}

export function isClientOwner(user) {
  return Boolean(
    user &&
    user.accountType === CLIENT_ACCOUNT_TYPE &&
    user.role === CLIENT_OWNER_ROLE
  );
}
